'use strict';
(function () {
  if (!customElements.get('showcase-scroller')) {
    class ShowcaseScroller extends HTMLElement {
      constructor() {
        super();
        this.onScroll = this.onScroll.bind(this);
        this.container = this.querySelector('.showcase-scroller__inner');
        this.observer = null;
        this.isInView = false;
        this.elementHeight = 0;
        this.ticking = false;
      }

      connectedCallback() {
        this.initializeIntersectionObserver();
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      disconnectedCallback() {
        this.cleanup();
      }

      onScroll() {
        if (!this.isInView || this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          const rect = this.getBoundingClientRect();
          const h = rect.height || this.elementHeight || 1;
          const viewportHeight = window.innerHeight;
          const scrolledThroughViewport = Math.min(Math.max(0, viewportHeight - rect.top), h + viewportHeight);
          const translateX = ((scrolledThroughViewport / h) * 100).toFixed(1);
          this.style.setProperty('--translate-x', `-${translateX}px`);
          this.ticking = false;
        });
      }

      initializeIntersectionObserver() {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.isInView = entry.isIntersecting;
            if (entry.boundingClientRect && entry.boundingClientRect.height) {
              this.elementHeight = entry.boundingClientRect.height;
            }
          });
        }, { root: null, rootMargin: '0px', threshold: [0] });
        this.observer.observe(this);
      }

      cleanup() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('scroll', this.onScroll);
      }
    }

    customElements.define('showcase-scroller', ShowcaseScroller);
  }
})();
